/* Progressive enhancements: all original sections and purchase forms remain. */
(function () {
  'use strict';
  const api = window.AminoBae;
  if (!api) return;
  const config = window.AminoBaeConfig || {};
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let railId = 0;
  function enhanceRails(scope) {
    if (config.railControls === false) return;
    scope.querySelectorAll('.swipe-rail').forEach(rail => {
      if (rail.dataset.railEnhanced || rail.closest('[hidden]')) return;
      rail.dataset.railEnhanced = 'true';
      if (!rail.id) rail.id = 'ab-rail-' + (++railId);
      const controls = document.createElement('div');
      controls.className = 'ab-rail-controls';
      controls.innerHTML = '<span class="ab-rail-controls__hint">Explore more</span><div class="ab-rail-controls__buttons"><button type="button" aria-label="Scroll back">←</button><button type="button" aria-label="Scroll forward">→</button></div>';
      const buttons = controls.querySelectorAll('button');
      buttons.forEach((button, i) => {
        button.setAttribute('aria-controls', rail.id);
        button.addEventListener('click', () => rail.scrollBy({
          left: (i ? 1 : -1) * rail.clientWidth * 0.8 * (getComputedStyle(rail).direction === 'rtl' ? -1 : 1),
          behavior: reducedMotion.matches ? 'auto' : 'smooth'
        }));
      });
      rail.after(controls);
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        const position = Math.abs(rail.scrollLeft);
        controls.hidden = max < 8;
        rail.tabIndex = max >= 8 ? 0 : -1;
        buttons[0].disabled = position < 4;
        buttons[1].disabled = position >= max - 4;
      };
      rail.addEventListener('scroll', update, {passive: true});
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(rail);
        rail._abResizeObserver = observer;
      }
      update();
    });
  }

  function enhanceTabs(scope) {
    scope.querySelectorAll('.tab-nav[role="tablist"], .pdp-tabs__nav[role="tablist"], .bcc__tabs[role="tablist"], .bcc__units[role="tablist"], .wa__metric-pills[role="tablist"], .collection-feature__tabs[role="tablist"]').forEach(list => {
      if (list.dataset.abTabs) return;
      list.dataset.abTabs = 'true';
      const tabs = Array.from(list.querySelectorAll('[role="tab"]'));
      const sync = () => tabs.forEach(tab => { tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1; });
      tabs.forEach((tab, index) => {
        const panelId = tab.getAttribute('aria-controls') || (tab.dataset.pdptab && 'pdptab-' + tab.dataset.pdptab);
        if (panelId) {
          tab.id = tab.id || 'ab-tab-' + panelId;
          tab.setAttribute('aria-controls', panelId);
          document.getElementById(panelId)?.setAttribute('aria-labelledby', tab.id);
        }
        tab.addEventListener('click', () => queueMicrotask(sync));
        tab.addEventListener('keydown', event => {
          const reverse = getComputedStyle(list).direction === 'rtl' ? -1 : 1;
          let next;
          if (event.key === 'ArrowRight') next = index + reverse;
          if (event.key === 'ArrowLeft') next = index - reverse;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          const target = tabs[(next + tabs.length) % tabs.length];
          target.focus(); target.click();
        });
      });
      sync();
    });
  }

  // Only handles are persisted; prices and availability come from the current market.
  async function initRecentlyViewed() {
    const section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    const key = 'aminobae_recently_viewed_v1';
    const stored = api.storage.get(key, []);
    const history = Array.isArray(stored) ? stored.filter(x => typeof x === 'string' && /^[\w-]+$/.test(x)) : [];
    const current = section.dataset.currentProduct;
    const handles = [...new Set(history)].filter(handle => handle !== current).slice(0, Number(section.dataset.limit) || 4);
    if (current) api.storage.set(key, [current, ...history.filter(handle => handle !== current)].slice(0, 12));
    if (!handles.length) return;
    const results = await Promise.allSettled(handles.map(async handle => {
      const response = await fetch(api.route('products/' + encodeURIComponent(handle) + '.js'));
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    }));
    const rail = section.querySelector('[data-recently-viewed-products]');
    results.forEach(result => {
      if (result.status !== 'fulfilled' || !result.value.title) return;
      const product = result.value;
      const card = document.createElement('article');
      card.className = 'ab-recent-card';
      const link = document.createElement('a');
      link.href = api.route('products/' + encodeURIComponent(product.handle));
      const media = document.createElement('div');
      media.className = 'ab-recent-card__media';
      if (product.featured_image) {
        const img = document.createElement('img');
        const url = new URL(product.featured_image, location.origin);
        if (['https:', 'http:'].includes(url.protocol)) {
          url.searchParams.set('width', '480');
          img.src = url.href;
          img.alt = '';
          img.width = 480; img.height = 480; img.loading = 'lazy';
          media.appendChild(img);
        }
      }
      const title = document.createElement('h3');
      title.textContent = product.title;
      const price = document.createElement('p');
      price.className = 'ab-recent-card__price';
      price.textContent = (product.price_varies ? 'From ' : '') + api.money(product.price);
      const action = document.createElement('span');
      action.className = 'ab-recent-card__action';
      action.textContent = product.available ? 'View product →' : 'View details · Sold out';
      link.append(media, title, price, action);
      card.appendChild(link);
      rail.appendChild(card);
    });
    if (!rail.children.length) return;
    section.hidden = false;
    enhanceRails(section);
    section.querySelector('[data-clear-recently-viewed]').addEventListener('click', () => {
      api.storage.set(key, []);
      section.hidden = true;
      // A removed section must not leave keyboard focus in hidden content.
      document.getElementById('main-content')?.focus({preventScroll: true});
      if (window.announceCart) window.announceCart('Recently viewed history cleared.');
    });
  }

  // Hidden drawers should never leak controls into the page's Tab order.
  function syncDialogs() {
    document.querySelectorAll('#cart-drawer, #mobile-nav, #search-panel').forEach(dialog => {
      dialog.inert = dialog.getAttribute('aria-hidden') === 'true';
    });
  }
  const dialogs = ['cart-drawer', 'mobile-nav', 'search-panel'].map(id => document.getElementById(id)).filter(Boolean);
  const dialogObserver = new MutationObserver(syncDialogs);
  dialogs.forEach(dialog => dialogObserver.observe(dialog, {attributes: true, attributeFilter: ['aria-hidden']}));
  syncDialogs();
  enhanceRails(document);
  enhanceTabs(document);
  initRecentlyViewed().catch(() => { /* Browsing history is optional, never blocks shopping. */ });
  document.addEventListener('shopify:section:load', event => { enhanceRails(event.target); enhanceTabs(event.target); });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.swipe-rail').forEach(rail => rail._abResizeObserver?.disconnect());
  });
})();
